import React, { useState } from 'react';
import '../styles/Review.css';
import { submitReview } from '../services/authService';
import appLogo from '../images/logo.png';

function Review() {
  const [formData, setFormData] = useState({
    staff_code: '',
    customer_name: '',
    customer_phone: '',
    email: '',
    stars: 0, // 1: Không hài lòng, 3: Bình thường, 5: Rất hài lòng
    note: ''
  });

  const [otherReview, setOtherReview] = useState({
    lich_su: false,
    thai_do_chua_tot: false,
    dieu_khien_an_toan: false
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleEmojiClick = (rating) => {
    setFormData(prev => ({...prev, stars: rating}));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleCheckboxChange = (name) => {
    setOtherReview(prev => ({...prev, [name]: !prev[name]}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.stars === 0) {
      setError('Vui lòng đánh giá sao cho lái đò');
      return;
    }

    setIsSubmitting(true);

    try {
      const reviewData = {
        ...formData,
        other_review: JSON.stringify({
          lich_su: otherReview.lich_su ? 1 : 0,
          thai_do_tot: otherReview.thai_do_tot ? 1 : 0,
          dieu_khien_an_toan: otherReview.dieu_khien_an_toan ? 1 : 0
        })
      };

      const response = await submitReview(reviewData);
      if (response.success) {
        setShowSuccess(true);
      } else {
        setError(response.message || 'Có lỗi xảy ra');
      }
    } catch (error) {
      setError('Không thể gửi đánh giá');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleStaffCodeChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 4)) {
      setFormData(prev => ({...prev, staff_code: value}));
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      setFormData(prev => ({...prev, customer_phone: value}));
    }
  };

  const renderEmojis = () => {
    const emojis = [
      { rating: 1, icon: '😠', label: 'Không hài lòng' },
      { rating: 3, icon: '😐', label: 'Bình thường' },
      { rating: 5, icon: '😊', label: 'Rất hài lòng' }
    ];

    return (
      <div className="review-emojis">
        {emojis.map(emoji => (
          <button
            key={emoji.rating}
            type="button"
            className={`emoji-btn ${formData.stars === emoji.rating ? 'active' : ''}`}
            onClick={() => handleEmojiClick(emoji.rating)}
          >
            <span className="emoji-icon">{emoji.icon}</span>
            <span className="emoji-label">{emoji.label}</span>
          </button>
        ))}
      </div>
    );
  };

  const renderSuccessModal = () => (
    <div className="review-modal-overlay">
      <div className="review-modal review-success-modal">
        <div className="review-success-icon">
          <i className="fas fa-check-circle"></i>
        </div>
        <h3>Cảm ơn bạn đã đánh giá!</h3>
        <p> Những góp ý của bạn sẽ được chúng tôi xem xét và cải thiện dịch vụ của mình.
          <br/>
          Chúc bạn và gia đình mạnh khỏe!
          <br/>
          <br/>
        </p>
      </div>
    </div>
  );

  const renderErrorModal = () => (
    <div className="review-modal-overlay">
      <div className="review-modal review-error-modal">
        <div className="review-error-icon">
          <i className="fas fa-exclamation-circle"></i>
        </div>
        <h3>Thông báo</h3>
        <p>{error}</p>
        <button 
          type="button" 
          className="review-close-btn"
          onClick={() => setError('')}
        >
          Đóng
        </button>
      </div>
    </div>
  );

  return (
    <div className="review-container">
      <main className="review-main">
        <form onSubmit={handleSubmit} className="review-form">
          <div className="review-header">
            <div className="review-logo">
              <img src={appLogo} alt="Logo" />
            </div>
            <h1>Đánh giá lái đò</h1>
          </div>
          <div className="review-group">
            <label>Mã lái đò <span className="required">*</span></label>
            <input
              type="text"
              name="staff_code"
              value={formData.staff_code}
              onChange={handleStaffCodeChange}
              required
              placeholder="Nhập mã lái đò (tối đa 4 số)"
              pattern="\d{1,4}"
              maxLength={4}
              inputMode="numeric"
            />
          </div>

          <div className="review-group">
            <label>Họ tên khách <span className="required">*</span></label>
            <input
              type="text"
              name="customer_name"
              value={formData.customer_name}
              onChange={handleInputChange}
              required
              placeholder="Nhập họ tên"
            />
          </div>

          <div className="review-group">
            <label>Số điện thoại <span className="required">*</span></label>
            <input
              type="tel"
              name="customer_phone"
              value={formData.customer_phone}
              onChange={handlePhoneChange}
              required
              placeholder="Nhập số điện thoại"
              pattern="\d{10}"
              maxLength={10}
              inputMode="numeric"
            />
          </div>

          <div className="review-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Nhập email"
            />
          </div>

          <div className="review-group review-emojis-group">
            {renderEmojis()}
          </div>

          <div className="review-group">
            <label>Danh sách nội dung đánh giá:</label>
            <div className="review-checkboxes">
              <label className="review-checkbox">
                <input
                  type="checkbox"
                  checked={otherReview.lich_su}
                  onChange={() => handleCheckboxChange('lich_su')}
                />
                <span>&nbsp;Lịch sự</span>
              </label>
              <label className="review-checkbox">
                <input
                  type="checkbox"
                  checked={otherReview.thai_do_tot}
                  onChange={() => handleCheckboxChange('thai_do_tot')}
                />
                <span>&nbsp;Thái độ tốt</span>
              </label>
              <label className="review-checkbox">
                <input
                  type="checkbox"
                  checked={otherReview.dieu_khien_an_toan}
                  onChange={() => handleCheckboxChange('dieu_khien_an_toan')}
                />
                <span>&nbsp;Điều khiển an toàn</span>
              </label>
            </div>
          </div>

          <div className="review-group">
            <label>Nội dung đánh giá</label>
            <textarea
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              placeholder="Nhập nội dung đánh giá"
              rows="4"
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="review-submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                <span>Đang gửi...</span>
              </>
            ) : (
              'Gửi đánh giá'
            )}
          </button>

          <div className="powered-by">
            Powered by <a href="https://thinksoft.com.vn/" target="_blank" rel="noopener noreferrer">thinksoft.com.vn</a>
          </div>
        </form>
      </main>

      {showSuccess && renderSuccessModal()}
      {error && renderErrorModal()}
    </div>
  );
}

export default Review;
